import { render, staticRenderFns } from "./ViewGatGridOverview.vue?vue&type=template&id=0213f2f3&scoped=true&"
import script from "./ViewGatGridOverview.vue?vue&type=script&lang=js&"
export * from "./ViewGatGridOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0213f2f3",
  null
  
)

export default component.exports